export default {"src":"/_next/static/media/arrow-left.2b3d2dbe.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};